import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/Card";
import Logo from '../../assets/images/IRStructureLogo.png';
import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { verifyEmail } from '../../store/actions/auth/verifyAction';
import Loading from "../../components/common/Loading";
import { CheckCircle, XCircle } from "lucide-react";
import { Button } from "../../components/ui/button";

const VerifyEmail = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const [isVerified, setIsVerified] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);

    useEffect(() => {
        if (token) {
            dispatch(verifyEmail(token, navigate, setIsVerified)).then((res) => {
                if (res?.success) {
                    setIsSuccess(true)
                }
            })
        }
    }, [token])

    return (
        <div className='flex justify-center items-center h-screen p-4'>
            <Card className="max-w-2xl w-full relative" >
                <div className='flex justify-center items-center'>
                <img className='absolute -top-16 left-[30%] w-56' src={Logo} alt="" />
                </div>
                <CardHeader>
                    <CardTitle className="text-center text-xl font-500">Verify Email</CardTitle>
                </CardHeader>
                <CardContent>
                    {isVerified ? <div className="space-y-6">
                        <div className="flex justify-center">
                            <Loading />
                        </div>
                        <div className="flex flex-col items-center justify-center">
                            <h2 className="text-lg font-semibold text-gray-900 mb-2">Verifying...</h2>
                            <p className="text-gray-600">Please wait while we verify your email address.</p>
                        </div>
                    </div> : isSuccess ? <div className="space-y-6">
                        <div className="flex justify-center">
                            <div className="relative">
                                <div className="w-20 h-20 bg-green-50 rounded-full flex items-center justify-center">
                                    <CheckCircle className="w-10 h-10 text-green-600" />
                                </div>
                                <div className="absolute inset-0 animate-pulse"></div>
                            </div>
                        </div>
                        <div className="flex flex-col items-center justify-center !mt-3">
                            <h2 className="text-lg font-semibold text-green-900 mb-2">Email Verified!</h2>
                            <p className="text-gray-600">Your email has been verified successfully.</p>
                        </div>
                    </div> : <div className="space-y-6">
                        <div className="flex justify-center">
                            <div className="relative">
                                <div className="w-20 h-20 bg-red/20 rounded-full flex items-center justify-center">
                                    <XCircle className="w-10 h-10 text-red" />
                                </div>
                                <div className="absolute inset-0 rounded-full animate-pulse"></div>
                            </div>
                        </div>
                        <div className="flex flex-col items-center justify-center !mt-3">
                            <h2 className="text-lg font-semibold text-red mb-2">Email Verification Failed!</h2>
                            <p className="text-gray-600">Your email verification failed. Please try again.</p>
                            <Button
                                className="w-full mt-5"
                                onClick={() => navigate("/login", { replace: true })}
                            >
                                Sign In
                            </Button>
                        </div>
                    </div>}
                </CardContent>
            </Card>
        </div>
    )
}

export default VerifyEmail